import { useMutation } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { toast } from 'react-toastify';
import { useGetContestQuery } from '../contests/getContest';

const deleteRound = (contestWeekId: string) =>
  api.delete(`/contest-weeks/${contestWeekId}`);

export const useDeleteRoundMutation = (contestId: number) => {
  const { refetch } = useGetContestQuery(contestId);

  return useMutation({
    mutationKey: ['delete-round', contestId],
    mutationFn: deleteRound,
    onSuccess: () => {
      toast.success('Round deleted successfully');
      refetch();
    },
    onError: (error) => {
      Promise.reject(error); // catch error in ErrorBoundary
    },
  });
};
